<template>
  <div class="btn-group btn-group-sm my-0">
    <AppButton
      v-for="(dayLetter, dayIndex) in weekdays"
      :key="dayLetter"
      :disabled="disabled"
      :raised="value.includes(dayIndex)"
      class="rounded-3"
      @click="update(dayIndex)"
    >
      {{ dayLetter }}
    </AppButton>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DaysSelect',
  inheritAttrs: false,
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    weekdays () {
      return moment.weekdays().map(dayName => dayName === 'Thursday' ? 'R' : dayName.charAt(0))
    },
  },
  methods: {
    update (dayIndex) {
      const newValue = this.value.includes(dayIndex)
        ? this.value.filter(index => index !== dayIndex)
        : this.value.concat(dayIndex).sort()
      this.$emit('input', newValue)
    },
  },
}
</script>

<style scoped>
  .btn-group {
    height: 36px;
  }
</style>
